/*=========================================================================================
  File Name: moduletypologyActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	routing({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/routing", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	getRoutingDone({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get("/routingdone/" + id + "/0")
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	upload({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/upload", payload)
				.then((response) => {
					commit("SAVE_UPLOAD", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	uploadValidate({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/uploadvalidate", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchUploadFileFilter({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/upload/filter", payload)
				.then((response) => {
					commit("SAVE_UPLOAD_FILE", response.data.records);
					commit("SET_UPLOAD_FILE_PAGINATION", response.data.pagination);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	updatePagination({commit}, payload) {
		commit("SET_UPLOAD_FILE_PAGINATION", payload);
	},
	fetchDataUploadFile({commit}, uploadId) {
		return new Promise((resolve, reject) => {
			Api.get(`/datauploads/${uploadId}/0`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	updateRecordDataUploadFile({commit}, uploadItem) {
		return new Promise((resolve, reject) => {
			Api.put(`/datauploads/${uploadItem.key}`, uploadItem)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	fetchBasicSkills({commit}) {
		return new Promise((resolve, reject) => {
			Api.get(`/skills`)
				.then((res) => {
					commit("SET_SKILLS", res.data);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	updateTipology({commit}, tipology) {
		return new Promise((resolve, reject) => {
			Api.put(`/typology/${tipology.id}`, tipology)
				.then((response) => {
					commit("UPDATE_TIPOLOGY", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	removeUploadFile({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.delete(`/upload/${id}`)
				.then((response) => {
					commit("REMOVE_UPLOAD", id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	setDescription({commit}, data) {
		return new Promise((resolve, reject) => {
			commit("SET_DESCRIPTION", data);
			resolve(data);
		});
	},
	setName({commit}, index, name) {
		commit("SET_NAME", index, name);
	},
	fetchCapacityNames({commit}) {
		return new Promise((resolve, reject) => {
			Api.get(`/resource/capacity`)
				.then((res) => {
					commit("SET_CAPACITIES_NAMES", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
